import { IPV4_RE, IPV6_RE, FQDN_RE } from '../regexes';

export function validateFqdn(value) {
    if (typeof value !== 'string') {
        return false;
    }
    return IPV4_RE.test(value) || IPV6_RE.test(value) || FQDN_RE.test(value);
}
